import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import ScrollHorizontal from '../../ui/scrollHorizontal/ScrollHorizontal';
import CourseGalleryItem from './courseGalleryItem/CourseGalleryItem';
import classes from './CourseGallery.module.css';

const CourseGallery = ({ courses = [], title = "courseGallery", description, showDiscoverMore = true, onDiscoverMoreClick, color, promoImg }) => {

    const { texts } = useSelector(state => state.translate);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsPerView, setItemsPerView] = useState(0);
    const containerRef = useRef(null);
    const ITEM_WIDTH = 195;
    const promoItems = useMemo(() => promoImg ? [{ type: 'promo', src: promoImg }] : [], [promoImg]);

    const items = useMemo(() => [...promoItems, ...courses], [courses, promoItems]);

    const totalItems = items?.length;

    useEffect(() => {
        setCurrentIndex(0);
    }, [totalItems]);

    useEffect(() => {
        const calculateItemsPerView = () => {
            if (!containerRef.current)
                return;

            const containerWidth = containerRef.current.offsetWidth;
            const availableWidth = containerWidth; // gap 20px each side
            const calculated = (availableWidth / ITEM_WIDTH);
            setItemsPerView(Math.floor(calculated));
        };

        calculateItemsPerView();
        window.addEventListener('resize', calculateItemsPerView);
        return () => window.removeEventListener('resize', calculateItemsPerView);
    }, [containerRef, courses]);

    const handleNext = () => {
        const maxIndex = Math.max(0, totalItems - itemsPerView);
        setCurrentIndex(prev => Math.min(maxIndex, prev + 1));
    };

    const handlePrevious = () => {
        setCurrentIndex(prev => Math.max(0, prev - 1));
    };

    // const handleDiscoverMore = () => {
    //     if (onDiscoverMoreClick) {
    //         onDiscoverMoreClick();
    //     }
    // };

    if (!courses || courses?.length === 0) {
        return null;
    }

    const maxIndex = Math.max(0, totalItems - itemsPerView);
    const hasMore = totalItems > itemsPerView;
    const showLeftArrow = hasMore && currentIndex < maxIndex;
    const showRightArrow = hasMore && currentIndex > 0;
    const renderCourseItems = () => (
        <>
            {items.map((item, index) =>
                item.type === 'promo'
                    ? <img src={item.src} className={classes.Img} />
                    : <div key={index} className={classes.CourseWrapper}>
                        <CourseGalleryItem course={item} />
                    </div>
            )}
        </>
    );

    return (
        <div className={classes.CourseGallery} style={{ background: color }}>
            <div className={classes.GalleryHeader}>
                <h3 className={classes.GalleryTitle}>{title}</h3>
                {description && <p className={classes.GalleryDescription}>{description}</p>}
            </div>
            <div className={classes.GalleryContainer}>
                {showRightArrow && (
                    <button className={`${classes.NavigationButton} ${classes.RightNavigationButton}`} onClick={handlePrevious} aria-label={texts.previous} >
                        <span className={classes.Arrow}>‹</span>
                    </button>
                )}

                <div className={classes.CoursesContainer} ref={containerRef}>
                    <div
                        className={classes.CoursesWrapper}
                        style={{ transform: `translateX(${currentIndex * (195 + 25)}px)` }}>
                        {renderCourseItems()}
                    </div>
                </div>

                {showLeftArrow && (
                    <button className={`${classes.NavigationButton} ${classes.LeftNavigationButton}`} onClick={handleNext} aria-label={texts.next}>
                        <span className={classes.Arrow}>›</span>
                    </button>
                )}
                <ScrollHorizontal height="100%" className={classes.GalleryScroll} showDots={true} dropClass={classes.MobileCoursesContainer} downDropStyle={classes.MobileCoursesWrapper}>
                    {renderCourseItems()}
                </ScrollHorizontal>
            </div>
            {/* no for the first time */}
            {/* {showDiscoverMore && (
                <div className={classes.DiscoverMore}>
                    <span className={classes.DiscoverMoreText} onClick={handleDiscoverMore}>
                        {texts.discoverMore} ››
                    </span>
                </div>
            )} */}
        </div>
    );
};

export default CourseGallery;
